import { useIntl } from "react-intl";

import { useFeatureIsOn } from "@/app/featureFlags";
import { Button } from "@/components/Button/Button";
import { PersistentDrawer } from "@/components/Drawer";
import { usePaymentContext } from "@/contexts/PaymentContext";

export const BottomDrawer = ({
  totalPrice,
  buttonLabel,
  onButtonClick,
  disabled,
  loading,
  showPayLater = false,
  payLaterPrice,
}: {
  totalPrice?: string;
  payLaterPrice?: string;
  buttonLabel: string;
  onButtonClick: () => void;
  disabled: boolean;
  loading?: boolean;
  showPayLater?: boolean;
}) => {
  const intl = useIntl();
  const { paymentType, isEligible } = usePaymentContext();
  const isBnplFeatureEnabled = useFeatureIsOn("bnpl");

  const isBnpl = paymentType === "bnpl";

  return (
    <PersistentDrawer>
      <div className="flex h-full flex-col gap-4">
        {isBnplFeatureEnabled &&
          Boolean(isEligible) &&
          (isBnpl || showPayLater) &&
          payLaterPrice && (
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-text-primary">
                {intl.formatMessage({
                  defaultMessage: "Pay later price per month",
                  description:
                    "Label showing the monthly installment price for the pay-later option",
                })}
              </span>
              <span className="text-md font-semibold">{payLaterPrice}</span>
            </div>
          )}
        {totalPrice ? (
          <div className="flex items-center justify-between">
            <h5 className="text-sm font-semibold text-text-primary">
              {intl.formatMessage({
                defaultMessage: "Standard price",
                description:
                  "Label for the full standard price in payment options",
              })}
            </h5>

            <span className="text-md font-semibold">{totalPrice}</span>
          </div>
        ) : null}

        <Button
          fullWidth
          variant="contained"
          onClick={onButtonClick}
          disabled={disabled}
          loading={loading}
        >
          {buttonLabel}
        </Button>
      </div>
    </PersistentDrawer>
  );
};
